import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNav from "@artibulles-cis/react/TabNav";

import Reconciliation from "./Reconciliation";
import AllTransactions from "./ReconciliationTables/AllTransactions";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabNavLink: {
        borderRight: "1px solid rgb(220 220 220)",
    },
}));

const Component = React.memo(function Component(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    return (
        <TabNav
            MainSlug={`/financials/accounting/accountsandtransactions/reconciliation`}
            DefaultTab={`/financials/accounting/accountsandtransactions/reconciliation/all`}
            ClassExtendTabNavLink={classes.ClassExtendTabNavLink}
            TabNavMenuHeight="30px"
            ActiveIndicator={{
                WithIndicator: true,
                Position: "Bottom",
            }}
            TabMenuContent={[
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>All</div>
                        </div>
                    ),
                    Slug: `/financials/accounting/accountsandtransactions/reconciliation/all`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <AllTransactions />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Bank Transactions</div>
                        </div>
                    ),
                    Slug: `/financials/accounting/accountsandtransactions/reconciliation/banktransactions`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <Reconciliation />,
                },
                {
                    TabMenu: (
                        <div className={classes.TabMenuDiv}>
                            <div className={classes.TabTitle}>Credit Card Transactions</div>
                        </div>
                    ),
                    Slug: `/financials/accounting/accountsandtransactions/reconciliation/creditcardstransactions`,
                    ShowOnlyIfActive: false,
                    exact: true,
                    TabContent: <Reconciliation />,
                },
            ]}
        />
    );

    /***************** RENDER ******************/
});

export default Component;
